import { render, staticRenderFns } from "./VideoLightBox.vue?vue&type=template&id=c113af18&"
import script from "./VideoLightBox.vue?vue&type=script&lang=js&"
export * from "./VideoLightBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports